var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentLikeNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6634 13.2575C53.416 29.7524 37.2743 44.1108 27.9793 49.6456C27.5419 49.906 26.9985 49.5849 26.9985 49.0759V43.7949C26.9985 43.477 26.7665 43.2024 26.4557 43.1362C11.105 39.866 8.20981 30.5941 8.0072 25.5232C7.37485 9.69732 20.0351 4.00002 26.9985 4C36.471 3.99997 41.3423 9.88128 43.6634 13.2575Z",
    stroke: "#00AFF0",
    strokeWidth: 4.67323
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentLikeNotification);
export default __webpack_public_path__ + "static/media/CommentLikeNotification.626b1d01ab77f01e7360fd13c52c3bdf.svg";
export { ForwardRef as ReactComponent };